module.exports = __webpack_public_path__ + "img/9.f5d00abd.svg";